import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { IRowData } from "@multiweb/types/contracts";
import { CancellationToken } from "@multiweb/types/multiweb";
import { IDataSourceLoadInfo } from "Global/Base/DataSources/Interfaces";
import { AttrValueReader } from "OW.Remoting/Remoting/AttrValueReader";
import { CommentaryFrameDataSource, ICommentaryDataSourceLoadInfo, ICommentRowData } from "./CommentaryFrameDataSource";
import { IDBDataSourceLoadParams } from "./DBDataSource";

//@ts-ignore
const logger = LazyLoadingSectionLogger.create(LoggingSection.dataSource); // logger pro konkrétní oblast

export class CommentaryFrameDataSourceFullTree extends CommentaryFrameDataSource {
    private _fullRowMap: Map<string, ICommentRowData> = new Map;
    protected override _condUpdaterBeforeLoadNewData(): void {
        // Prázdná metoda
    }

    protected override async _processRows(params: IDBDataSourceLoadParams, cancellationToken: CancellationToken, rows: IRowData[], _startIndex: number): Promise<IDataSourceLoadInfo> {
        let tempInternal = rows.map((item) => this._rowToInternalRow(item));

        if (tempInternal.length > 0) {
            const rowIds = rows.map((item) => AttrValueReader.readRow(item, this.dataKey));

            tempInternal = this._processFullTree(tempInternal);
            //priradi se prilohy pro nove stazena data
            if (this._attachmentclass)
                await this._addAttachment(tempInternal, rowIds);
        }
        this._internalRows = tempInternal;

        this._dsLoadInfo = this._afterProcessRow(params, cancellationToken) as ICommentaryDataSourceLoadInfo;
        this.loadingEnded.trigger(this, this._dsLoadInfo);

        return this._dsLoadInfo;
    }

    //prida prilohu k zaznamu
    protected override _fillAttachment(_tempInternal: ICommentRowData[], attachmentRows: IRowData[]): void {
        for (const attachment of attachmentRows) {
            const commentRow = this._fullRowMap.get(AttrValueReader.readRow(attachment, this.attachmentLinkToAttr));
            if (commentRow) {
                commentRow.attachments.push({
                    id: AttrValueReader.readRow(attachment, this.dataKey),
                    attachmentLinkToAttr: AttrValueReader.readRow(attachment, this.attachmentLinkToAttr),
                    attachmentAttribute: AttrValueReader.readRow(attachment, this.attachmentAttribute),
                });
            }
        }
    }

    protected _processFullTree(rows: ICommentRowData[]): ICommentRowData[] {
        const rowMap = new Map<string, ICommentRowData>();
        const rowWaiterMap = new Map<string, Array<{ dataKey: string; parentDataKey: string; row: ICommentRowData }>>();
        const rootObjs = [];

        const f_checkAndAdd = (parentDataKey: string) => {
            if (rowWaiterMap.has(parentDataKey) && rowMap.has(parentDataKey)) {
                for (const rowItem of rowWaiterMap.get(parentDataKey)) {
                    rowMap.get(parentDataKey).children.push(rowItem.row);
                    rowMap.set(rowItem.dataKey, rowItem.row);
                }
                rowWaiterMap.delete(parentDataKey);
            }
        };

        for (const row of rows) {
            const dataKey = AttrValueReader.readRow(row.data, this.dataKey);
            const parentId = AttrValueReader.readRow(row.data, this.hierarchy);
            this._fullRowMap.set(dataKey, row);

            if (parentId == null || parentId == 0) {
                rowMap.set(dataKey, row);
                rootObjs.push(row);
                f_checkAndAdd(dataKey);
            } else if (rowMap.has(parentId)) {
                rowMap.get(parentId).children.push(row);
                rowMap.set(dataKey, row);
                f_checkAndAdd(dataKey);
            } else {
                if (rowWaiterMap.has(parentId))
                    rowWaiterMap.get(parentId).push({ dataKey: dataKey, parentDataKey: parentId, row: row });
                else
                    rowWaiterMap.set(parentId, [{ dataKey: dataKey, parentDataKey: parentId, row: row }]);
            }
        }

        let rowWaiterLength;
        do {
            rowWaiterLength = rowWaiterMap.size;
            for (const parentId of rowWaiterMap.keys()) {
                f_checkAndAdd(parentId);
            }
        } while (rowWaiterLength > rowWaiterMap.size);

        if (rowWaiterMap.size > 0) {
            logger.warn("No parent found");
        }

        return rootObjs;
    }
}
